import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  upgradeTenantToPartner,
  UpgradeTenantToPartnerPayload,
  UpgradeTenantToPartnerResponse,
} from '../../api/queries';

const TENANTS_QUERY_KEY = ['GET_TENANTS'];
const TENANT_DETAIL_QUERY_KEY = 'GET_TENANT_DETAIL';

export const useUpgradeTenantToPartnerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      tenantId,
      payload,
    }: {
      tenantId: number;
      payload: UpgradeTenantToPartnerPayload;
    }): Promise<UpgradeTenantToPartnerResponse> => {
      return upgradeTenantToPartner(tenantId, payload);
    },
    onSuccess: (_, variables) => {
      // Invalidate tenants list to refresh the list view
      queryClient.invalidateQueries({ queryKey: TENANTS_QUERY_KEY });

      // Invalidate the specific tenant detail to refresh the detail view
      queryClient.invalidateQueries({
        queryKey: [TENANT_DETAIL_QUERY_KEY, variables.tenantId]
      });
    },
  });
};
